import React, { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { Row, Col } from "antd";

import { groupBy } from "../../modules/linq";
import { warn } from "../../modules/messages";
import { loadProducts } from "../../modules/staticDataLoad";
import LoadError from "../../components/app/generic/loadError";
import LoadSkeleton from "../../components/app/generic/loadSkeleton";
import ProductChoice from "../../components/consignment/productChoice";
import ConsignmentForm from "../../components/consignment/consignmentForm";
import { CONSIGNMENT_REQUEST_RESET } from "../../modules/redux/actionNames";
import ConsignmentHeader from "../../components/consignment/consignmentHeader";
import ConsignmentDetailInfo from "../../components/consignmentDetail/consignmentDetailInfo";

function Consignment({
  edit,
  detail,
  loading,
  consignment,
  fromTemplate,
  onLoadConsignment,
}) {
  const [current, setCurrent] = useState();
  useEffect(() => {
    setCurrent(consignment);
  }, [consignment]);

  const intl = useIntl();
  const [product, setProduct] = useState();
  const handleProductClick = useCallback((product) => {
    setProduct(product);
  }, []);

  const handleDropProduct = useCallback(() => {
    setProduct();
  }, []);

  const [products, setProducts] = useState();
  const [productGroups, setProductGroups] = useState();
  const handleSetProducts = useCallback((loadedProducts) => {
    setProducts(loadedProducts);
    setProductGroups(
      loadedProducts && loadedProducts !== "e"
        ? groupBy(
            loadedProducts,
            (v) => (v.productGroup && v.productGroup.name) || "--"
          )
        : loadedProducts
    );
  }, []);

  const onLoadProducts = useCallback(() => {
    !detail && loadProducts(handleSetProducts);
  }, [detail, handleSetProducts]);

  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.consignmentRequest);
  useEffect(() => {
    if (data && products && products !== "e") {
      !consignment && setCurrent(data);
      dispatch({ type: CONSIGNMENT_REQUEST_RESET });
    }
  }, [data, dispatch, products, consignment]);

  useEffect(() => {
    onLoadProducts();
  }, [onLoadProducts, intl.locale]);

  useEffect(() => {
    if (current && ((products && products !== "e") || detail)) {
      const loadedProduct = current.product;
      if (detail) {
        setProduct(loadedProduct);
      } else {
        const currentProduct = products.find((p) => p.id === loadedProduct.id);
        !currentProduct &&
          warn(
            intl.formatMessage({
              id: "consignment.unknownProduct",
              defaultMessage:
                "Proběhla automatická změna produktu! Zkontrolujte prosím korektnost adres. Dříve vybraný produkt již nemáte aktivní.",
            }),
            20
          );
        setProduct(currentProduct);
      }
      if (fromTemplate) {
        current.templateName = undefined;
      }
    }
  }, [intl, detail, current, fromTemplate, products]);

  return (
    <Row>
      <Col>
        <ConsignmentHeader
          edit={edit}
          detail={detail}
          product={product}
          productGroups={productGroups}
          onButtonClick={handleDropProduct}
          onProductSelect={handleProductClick}
          templateName={current && current.templateName}
        />
        {loading ? (
          <LoadSkeleton
            colProps={{ sm: 24, xxl: 18 }}
            rowProps={{ type: "flex", justify: "center", gutter: [0, 100] }}
          />
        ) : current === "e" ? (
          <LoadError
            onClick={onLoadConsignment}
            message={intl.formatMessage({
              id: "consignment.loadError",
              defaultMessage: "Při načítání zásilky nastala chyba",
            })}
          />
        ) : product ? (
          <Row gutter={[0, 100]}>
            <Col>
              {detail && <ConsignmentDetailInfo consignment={current} />}
              <ConsignmentForm
                edit={edit}
                detail={detail}
                product={product}
                consignment={current}
                onLoadConsignment={onLoadConsignment}
              />
            </Col>
          </Row>
        ) : (
          <ProductChoice
            productGroups={productGroups}
            onLoadProducts={onLoadProducts}
            onProductClick={handleProductClick}
          />
        )}
      </Col>
    </Row>
  );
}

export default Consignment;
